import { render, staticRenderFns } from "./salesTableShbj.vue?vue&type=template&id=4736cb0c"
import script from "./salesTableShbj.vue?vue&type=script&lang=js"
export * from "./salesTableShbj.vue?vue&type=script&lang=js"
import style0 from "./salesTableShbj.vue?vue&type=style&index=0&id=4736cb0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports